import React, { Fragment, useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "../tss";
import { styled } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Rocketmail from "../images/Rocketmail.png";
import { useNavigate, useLocation } from "react-router-dom";
import { SIGNIN_ROUTE } from "../constants/RoutePaths";
import { VERIFY_EMAIL_URL } from "../common/url";
import API from "../constants/API";
import { useSnackbar } from "notistack";
import { CustomMessage } from "../common/helperfunction";

const useStyles = makeStyles((_theme) => ({
  shadow1: {
    width: "100%",
    backgroundColor: "unset !important",
    boxShadow: "none !important",
    padding: "24px",
    marginTop: "48px",
  },
  regimg: {
    width: "25%",
  },
  regtext: {
    // width: "72%",
    // display: "flex",
    margin: "auto !important",
    // [theme.breakpoints.up("md")]: {
    //   width: "100%",
    // },
  },
  pleasetext: {
    margin: "auto !important",
    fontSize: "14px !important",
    color: "#A0A3BD !important",
  },
  buttontext: {
    backgroundColor: "#EC7C37 !important",
    boxShadow: "none !important",
    "&:hover": {
      color: "#EC7C37 !important",
      border: "1px solid #EC7C37 !important",
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
    },
  },
}));

interface VerifyEmailProps {
  _classes?: string;
}

export default function VerifyEmail(props: VerifyEmailProps) {
  const location = useLocation();
  const styleclasses = useStyles();
  const _isFirsttime = useRef(true);
  const history = useNavigate();
  const { _classes } = props;
  const searchParams = new URLSearchParams(location.search);
  const [_loading, _setLoading] = useState(false);
  const [data, setData] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "var(--bg-surface)",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const gotoSigin = () => {
    history(SIGNIN_ROUTE);
  };

  useEffect(() => {
    VerifyEmail();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- mount-once: verify email from URL params on initial load

  const VerifyEmail = async () => {
    const emailvalue = searchParams.get("email");
    const newEmailValue = decodeURIComponent((emailvalue ?? "").replace(" ", "+"));
    const config = {
      method: "PUT",
      url: VERIFY_EMAIL_URL,
      data: {
        email: newEmailValue,
        hashKey: searchParams.get("hashKey"),
      },
    };
    try {
      const response = await API(config);
      //const { status, message } = response.data;
      const { status, message } = response.data;

      if (status === "Success") {
        setData("Thank you. You have successfully verified your email address with us");
        //Swal.fire(getAlertToast("success", "Email Verified Successfully"));
        CustomMessage("Email verified", "success", enqueueSnackbar);
      } else {
        setData(message);
        // Swal.fire(getAlertToast(message));
        CustomMessage(message, "error", enqueueSnackbar); //call toster
      }
    } catch (error) {
      const err = error as { response?: { data?: { message?: string } }; message?: string };
      // let errorObj = Object.assign({}, error);
      // let { data } = errorObj.response;
      if (err.response) {
        const { data } = err.response;

        const v = data;

        setData(v?.message ?? "");

        CustomMessage(v?.message, "error", enqueueSnackbar); //call toster
      }
    }
  };

  return (
    <Fragment>
      <Box sx={{ width: "100%", mt: 2 }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          rowSpacing={2}
          columnSpacing={{ xs: 4, sm: 4, md: 4 }}
        >
          <Grid
            size={{
              xs: 12,
              md: 12,
              lg: 12,
            }}
          >
            <Item className={styleclasses.shadow1}>
              <img src={Rocketmail} className={styleclasses.regimg} alt="Email verification" />
            </Item>

            <Grid
              className={styleclasses.regtext}
              size={{
                xs: 12,
                md: 12,
                lg: 12,
              }}
            >
              <Typography align="center" variant="h6">
                {data}
              </Typography>
            </Grid>
            {/* <Grid item xs={12} md={12} lg={12} sx={{ p: 2, fontWeight: 600 }}>
              <Typography align="center" className={styleclasses.pleasetext}>
                Please check your spam/junk folder if you do not see any
                messages from EZ Cloud in your inbox.
              </Typography>
            </Grid> */}
            <Grid
              sx={{ p: 2, fontWeight: 600 }}
              size={{
                xs: 12,
                md: 12,
                lg: 12,
              }}
            >
              <Button
                className={styleclasses.buttontext}
                variant="contained"
                onClick={() => gotoSigin()}
              >
                Signin
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  );
}
